import React from "react";
import {
  AppstoreOutlined,
  FileSearchOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UpCircleOutlined,
  FormOutlined,
  LinkOutlined,
  MoneyCollectOutlined,
  CalendarOutlined,
  CopyrightOutlined,
  MergeCellsOutlined,
  WalletOutlined
} from "@ant-design/icons";
import { Menu, Layout } from "antd";
// import "../SideBar/Sidebar.css";
import "../../GlobalCss/SPF/Sidebar.css";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import Logout from "../Logout/Logout";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CalendarView from "../../Pages/CalenderView/CalendarView";
import { decrypt } from "../../Utils/Utils";
import MenuItem from "antd/es/menu/MenuItem";
const { Sider } = Layout;

const tenantName = Cookies.get("tenant_name")

const routeToActivePageMap = {
  [`/${tenantName}/dashboard`]: "1",
  [`/${tenantName}/offcycle`]: "offcycle",
  [`/${tenantName}/newhiresrehires`]: "subitem1",
  [`/${tenantName}/healthinsurance`]: "subitem2",
  [`/${tenantName}/garnishments`]: "subitem3",
  [`/${tenantName}/timecards`]: "subitem4",
  [`/${tenantName}/masterfile`]: "subitem5",
  [`/${tenantName}/adjustments`]: "subitem6",
  [`/${tenantName}/audit`]: "subitem7",
  [`/${tenantName}/payrollchecklist`]: "subitem7",
  [`/${tenantName}/preview`]: "subitem7",
  [`/${tenantName}/finalmasteraudit`]: "subitem7",
  [`/${tenantName}/payrollhoursaudit`]: "subitem7",
  [`/${tenantName}/canadaautocrawl`]: "subitem9",
  [`/${tenantName}/canadapayroll`]: "subitem9",
  [`/${tenantName}/consolidateddata`]: "subitem9",
  [`/${tenantName}/canadamasterfile`]: "subitem9",
  [`/${tenantName}/prreportshomepage`]: "subitem8",
  [`/${tenantName}/prreportsmulticlients`]: "subitem8",
  [`/${tenantName}/expensemanagement`]: "4",
  [`/${tenantName}/corporateexpensemanagement`]: "4",
  [`/${tenantName}/glcodes`]: "4",
  [`/${tenantName}/billing`]: "17",
  [`/${tenantName}/billingcrawling`]: "22",
  [`/${tenantName}/billingmasterfile`]: "23",
  [`/${tenantName}/billinginvoiceuploadfile`]: "25",
  [`/${tenantName}/timesheetteam`]: "timesheetteam",
  [`/${tenantName}/clientservices`]: "clientservices",
  [`/${tenantName}/employeecare`]: "employeecare",
  [`/${tenantName}/timecardfollowupcrawling`]: "timecardfollowupcrawling",
  [`/${tenantName}/1099crawl`]: "20",
  [`/${tenantName}/1099`]: "20",
  [`/${tenantName}/1099masterfile`]: "20",
  [`/${tenantName}/statutoryreporting`]: "16",
  [`/${tenantName}/utilities`]: "5",
  [`/${tenantName}/activitylog`]: "5",
  [`/${tenantName}/analytics`]: "5",
  [`/${tenantName}/analytics 2`]: "5",
  [`/${tenantName}/updatecredentialGrid`]: "6",
  [`/${tenantName}/calendarview`]: "14",
  [`/${tenantName}/usermanagement`]: "7",
  [`/${tenantName}/spectranet`]: "9",
  [`/${tenantName}/paychex`]: "10",
  [`/${tenantName}/adp`]: "11",
  [`/${tenantName}/360Works`]: "12",
  [`/${tenantName}/peopleWorks`]: "13",
  [`/${tenantName}/expensescrawl`]: "expenses",
  [`/${tenantName}/accrualscrawling`]: "accruals"
};


const SideNavBar = () => {



  let history = useHistory();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const role = Cookies.get("Role");
  const Role = decrypt(role);
  const roles = Role.split(",").map(r => r.trim());
  console.log("role:", Role);
  const isSuperuser = roles.includes("Super User");
  const isUser = roles.includes("User");
  const isTimeSheetCoordinator = roles.includes("TimeSheet Coordinator");
  const isTenNinetyNine = roles.includes("TenNinetyNine Coordinator");
  const isBilling = roles.includes("Billing Coordinator");
  const isPRCoordinator = roles.includes("PR Coordinator");
  const isCanadaCoordinator = roles.includes("Canada Coordinator");
  const isUSCoordinator = roles.includes("US Coordinator");
  const isExpenses = roles.includes("Expenses");
  const isTimeCardFollowupCoordinator=roles.includes("TimeCardFollowup Coordinator");
  const isAutomatedUser=roles.includes("Automated User");
  const [activePage, setActivePage] = useState("1");


  useEffect(() => {
    const currentPath = location.pathname;
    const activeKey = routeToActivePageMap[currentPath] || "1"; // Default to "1" if path is unknown
    setActivePage(activeKey);
    localStorage.setItem("ActivePage", activeKey); // Sync with localStorage for intra-app navigation
  }, [location.pathname]);

  const handleMenuClick = (key, path) => {
    setActivePage(key);
    localStorage.setItem("ActivePage", key); // Update local storage for intra-app use
    history.push(path);
  };

  const goToSpectranet = () => {
    // window.location.href ="https://spectranet.spectraforce.com/#/main-dashboard/home"
    window.open('https://spectranet.spectraforce.com/#/main-dashboard/home', '_blank');
  }
  const goToPaychex = () => {
    // window.location.href ="https://spectranet.spectraforce.com/#/main-dashboard/home"
    window.open('https://myapps.paychex.com/landing_remote/login.do?lang=en', '_blank');
  }
  const goToAdp = () => {
    // window.location.href ="https://spectranet.spectraforce.com/#/main-dashboard/home"
    window.open('https://teampay.adp.com/Payroll/Admin/Main/Default.aspx#', '_blank');
  }
  const goToAdpWFN = () => {
    // window.location.href ="https://spectranet.spectraforce.com/#/main-dashboard/home"
    window.open('https://workforcenow.adp.com/theme/admin.html#/home', '_blank');
  }
  const goTo360Works = () => {
    // window.location.href ="https://spectranet.spectraforce.com/#/main-dashboard/home"
    window.open('https://360degree.work/TeamDashboard', '_blank');
  }
  const goToPeopleWorks = () => {
    // window.location.href ="https://spectranet.spectraforce.com/#/main-dashboard/home"
    window.open('https://www.peopleworks.ind.in/?p=0xwKNStd97U=&returnUrl=%2fSPECTRAFORCE%2fHLM%2fHome%2fIndex', '_blank');
  }

  return (
    <>
      <div className={collapsed ? "sider-collapsed" : "whole-sider-class"}>
        <Sider
          collapsible
          collapsed={collapsed}
          theme="light"
          trigger={null}
          onCollapse={(value) => setCollapsed(value)}
          className="sider-class"
        // width={"100%"}
        >
          {/* <div /> */}
          <div className="header-intime">
            <div className="sider-header" onClick={() => setCollapsed(!collapsed)}>
              {collapsed ? (
                <img src="/Images/Logo icon.png" alt="INTIME Logo Collapsed" className="sider-logoe" style={{ height: 40 }} />
              ) : (
                <img src="/Images/Logo.png" alt="INTIME Logo" className="sider-logo" />
              )}
            </div>

          </div>
          <Menu
            mode="inline"
            selectedKeys={[activePage]}
            defaultSelectedKeys={["1"]}
            className="items-class"
          >
            <Menu.Item key="1" icon={<img src="/Images/Icons/dashboard1.svg" alt="Dashboard" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />} onClick={() =>
              handleMenuClick("1", Role === "Super User" ? `/${tenantName}/admin-dashboard` : `/${tenantName}/dashboard`)}>


              Dashboard
            </Menu.Item>
            {(isSuperuser || isUser || isAutomatedUser) && (
              <>
                <Menu.SubMenu
                  key="2"
                  icon={
                    <img
                      src="/Images/Icons/RegularP.svg"
                      alt="Regular Payroll"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  title={
                    <span className="menu-item-text" title="Regular Payroll">
                      Regular Payroll
                    </span>
                  }
                >
                  <Menu.Item
                    key="subitem1"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem1", `/${tenantName}/newhiresrehires`)}
                  >
                    Newhires/Rehires
                  </Menu.Item>
                  <Menu.Item
                    key="subitem2"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem2", `/${tenantName}/healthinsurance`)}
                  >
                    Health Insurance
                  </Menu.Item>
                  <Menu.Item
                    key="subitem3"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem3", `/${tenantName}/garnishments`)}
                  >
                    Garnishments
                  </Menu.Item>
                  <Menu.Item
                    key="subitem4"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem4", `/${tenantName}/timecards`)}
                  >
                    Timecards
                  </Menu.Item>
                  <Menu.Item
                    key="subitem5"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem5", `/${tenantName}/masterfile`)}
                  >
                    Payroll Masterfile
                  </Menu.Item>
                  <Menu.Item
                    key="subitem6"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem6", `/${tenantName}/adjustments`)}
                  >
                    <span className="menu-item-text" title="Payroll Adjustments">
                      Payroll Adjustments
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="subitem7"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem7", `/${tenantName}/audit`)}
                  >
                    <span className="menu-item-text" title="Payroll Audit/Review">
                      Payroll Audit/Review
                    </span>
                  </Menu.Item>
                  {/* <Menu.Item
                    key="subitem9"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem9", `/${tenantName}/canadaautocrawl`)}
                  >
                    <span className="menu-item-text" title="Canada Payroll Audit/Review">
                      Canada Payroll Audit/Review
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="subitem8"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("subitem8", `/${tenantName}/prreportshomepage`)}
                  >
                    PR_Payroll
                  </Menu.Item> */}
                </Menu.SubMenu>

                <Menu.Item
                  key="offcycle"
                  className="menuicon-class"
                  icon={
                    <img
                      src="/Images/Icons/Offcycle1.svg"
                      alt="Off Cycle Payroll"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  onClick={() => handleMenuClick("offcycle", `/${tenantName}/offcycle`)}
                >
                  <span className="menu-item-text" title="Off Cycle Payroll">
                    Off Cycle Payroll
                  </span>
                </Menu.Item>

                <Menu.Item
                  key="4"
                  icon={
                    <img
                      src="/Images/Icons/ExpenseM.svg"
                      alt="Expense Management"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  onClick={() => handleMenuClick("4", `/${tenantName}/expensemanagement`)}
                >
                  <span className="menu-item-text" title="Expense Management">
                    Expense Management
                  </span>
                </Menu.Item>

                <Menu.SubMenu
                  key="billing"
                  icon={
                    <img
                      src="/Images/billing.svg"
                      alt="billing"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  title={<span className="menu-item-text" title="Billing">Billing</span>}
                >
                  <Menu.Item
                    key="17"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("17", `/${tenantName}/billing`)}
                  >
                    Billing
                  </Menu.Item>
                  <Menu.Item
                    key="22"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("22", `/${tenantName}/billingcrawling`)}
                  >
                    <span className="menu-item-text" title="Billing Audit/Review">
                      Billing Audit/Review
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="23"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("23", `/${tenantName}/billingmasterfile`)}
                  >
                    <span className="menu-item-text" title="Billing Masterfile">
                      Billing Masterfile
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="25"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("25", `/${tenantName}/billinginvoiceuploadfile`)}
                  >
                    <span className="menu-item-text" title="Billing Invoice Upload File">
                      Billing Invoice Upload File
                    </span>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.Item key= "accruals" icon={<WalletOutlined alt="Accruals" style={{fontSize: 25, marginRight: 8, color: "#425BF8"}} />} onClick={ ()=> handleMenuClick("accruals", `/${tenantName}/accrualscrawling`)}>
                Accruals
              </Menu.Item>

                <Menu.SubMenu
                  key="timecardfollowup"
                  icon={
                    <img
                      src="/Images/Icons/Timecard F.svg"
                      alt="TimeCard Followup"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  title={
                    <span className="menu-item-text" title="Timecard Followup">
                      TimeCard F...
                    </span>
                  }
                >
                  <Menu.Item
                    key="timesheetteam"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("timesheetteam", `/${tenantName}/timesheetteam`)}
                  >
                    <span className="menu-item-text" title="Timesheet Team">
                      Timesheet Team
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="clientservices"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("clientservices", `/${tenantName}/clientservices`)}
                  >
                    <span className="menu-item-text" title="Client Services">
                      Client Services
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="employeecare"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("employeecare", `/${tenantName}/employeecare`)}
                  >
                    <span className="menu-item-text" title="Employee Care">
                      Employee Care
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="timecardfollowupcrawling"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("timecardfollowupcrawling", `/${tenantName}/timecardfollowupcrawling`)}
                  >
                    <span className="menu-item-text" title="Timecard Followup Audit/Review">
                      Timecard Followup Audit/Review
                    </span>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.Item key= "subitem9" icon={<CopyrightOutlined alt="Canada"  style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }}/>}  onClick={() => handleMenuClick("subitem9", `/${tenantName}/canadaautocrawl`)}>
                Canada Payroll Audit/Review
              </Menu.Item>
              <Menu.Item key= "subitem8" icon={<MergeCellsOutlined alt="PR_Payroll"  style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }}/>} onClick={() => handleMenuClick("subitem8", `/${tenantName}/prreportshomepage`)}>
                PR_Payroll
              </Menu.Item>

                <Menu.Item
                  key="20"
                  icon={
                    <img
                      src="/Images/1099.svg"
                      alt="1099"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  onClick={() => handleMenuClick("20", `/${tenantName}/1099crawl`)}
                >
                  1099
                </Menu.Item>

                <Menu.Item
                  key="expenses"
                  icon={
                    <MoneyCollectOutlined
                      alt="expenses"
                      style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }}
                    />
                  }
                  onClick={() => handleMenuClick("expenses", `/${tenantName}/expensescrawl`)}
                >
                  Expenses
                </Menu.Item>

                <Menu.Item
                  key="16"
                  icon={
                    <img
                      src="/Images/Group 1012.svg"
                      alt="Reporting Module"
                      style={{ fontSize: 23, marginRight: 8 }}
                    />
                  }
                  onClick={() => handleMenuClick("16", `/${tenantName}/statutoryreporting`)}
                >
                  <span className="menu-item-text" title="Reporting Module">
                    Reporting Module
                  </span>
                </Menu.Item>

                <Menu.Item
                  key="5"
                  icon={
                    <img
                      src="/Images/Icons/Utilities1.svg"
                      alt="Utilities"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  onClick={() => handleMenuClick("5", `/${tenantName}/utilities`)}
                >
                  Utilities
                </Menu.Item>

                <Menu.Item
                  key="6"
                  icon={
                    <img
                      src="/Images/Icons/Paychex1.svg"
                      alt="Creds Handling"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  onClick={() => handleMenuClick("6", `/${tenantName}/updatecredentialGrid`)}
                >
                  Creds Handling
                </Menu.Item>

                {/* User Management visible only for superuser */}
                {isSuperuser && (
                  <Menu.Item
                    key="7"
                    icon={
                      <img
                        src="/Images/Icons/Settings.svg"
                        alt="User Management"
                        style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                      />
                    }
                    onClick={() => handleMenuClick("7", `/${tenantName}/usermanagement`)}
                  >
                    <span className="menu-item-text" title="User Management">
                      User Management
                    </span>
                  </Menu.Item>
                )}
              </>
            )}

            {isPRCoordinator && (
              <>
                 <Menu.Item key= "subitem8" icon={<MergeCellsOutlined alt="PR_Payroll"  style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }}/>} onClick={() => handleMenuClick("subitem8", `/${tenantName}/prreportshomepage`)}>
                PR_Payroll
              </Menu.Item>
              </>
            )}
            {isCanadaCoordinator && (
              <>
               
               <Menu.Item key= "subitem9" icon={<CopyrightOutlined alt="Canada"  style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }}/>}  onClick={() => handleMenuClick("subitem9", `/${tenantName}/canadaautocrawl`)}>
                Canada Payroll Audit/Review
              </Menu.Item>
              </>

            )}
            {isUSCoordinator && (
              <>

                <Menu.SubMenu
                  key="2"
                  icon={<img src="/Images/Icons/RegularP.svg" alt="Regular Payroll" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />}
                  title={<span className="menu-item-text" title="Regular Payroll">Regular Payroll</span>}
                >
                  <Menu.Item key="subitem1" className="menuicon-class" onClick={() => handleMenuClick("subitem1", `/${tenantName}/newhiresrehires`)} >
                    Newhires/Rehires
                  </Menu.Item>
                  <Menu.Item key="subitem2" className="menuicon-class" onClick={() => handleMenuClick("subitem2", `/${tenantName}/healthinsurance`)}>

                    Health Insurance
                  </Menu.Item>
                  <Menu.Item key="subitem3" className="menuicon-class" onClick={() => handleMenuClick("subitem3", `/${tenantName}/garnishments`)}>

                    Garnishments
                  </Menu.Item>
                  <Menu.Item key="subitem4" className="menuicon-class" onClick={() => handleMenuClick("subitem4", `/${tenantName}/timecards`)}>

                    Timecards
                  </Menu.Item>
                  <Menu.Item key="subitem5" className="menuicon-class" onClick={() => handleMenuClick("subitem5", `/${tenantName}/masterfile`)}>

                    Payroll Masterfile
                  </Menu.Item>
                  <Menu.Item key="subitem6" className="menuicon-class" onClick={() => handleMenuClick("subitem6", `/${tenantName}/adjustments`)}>

                    <span className="menu-item-text" title="Payroll Adjustments ">Payroll Adjustments</span>
                  </Menu.Item>
                  <Menu.Item key="subitem7" className="menuicon-class" onClick={() => handleMenuClick("subitem7", `/${tenantName}/audit`)}>

                    <span className="menu-item-text" title="Payroll Audit/Review">Payroll Audit/Review</span>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.Item key="offcycle" className="menuicon-class" icon={<img src="/Images/Icons/Offcycle1.svg" alt="Off Cycle Payroll" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />} onClick={() => handleMenuClick("offcycle", `/${tenantName}/offcycle`)}>
                  <span className="menu-item-text" title="Off Cycle Payroll">Off Cycle Payroll</span>
                </Menu.Item>
                <Menu.Item key="4" icon={<img src="/Images/Icons/ExpenseM.svg" alt="Expense Management" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />} onClick={() => handleMenuClick("4", `/${tenantName}/expensemanagement`)}>
                  <span className="menu-item-text" title="Expense Management">Expense Management</span>
                </Menu.Item>
              </>
            )}
            {isExpenses && (
              <>
                <Menu.Item key="expenses" icon={<MoneyCollectOutlined alt="expenses" style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }} />} onClick={() => handleMenuClick("expenses", `/${tenantName}/expensescrawl`)}>
                  Expenses
                </Menu.Item>
              </>
            )}
            {isBilling && (
              <>
                <Menu.SubMenu
                  key="billing"
                  icon={<img src="/Images/billing.svg" alt="billing" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />}
                  title={<span className="menu-item-text" title="Billing">Billing</span>}>
                  <Menu.Item key="17" className="menuicon-class" onClick={() => handleMenuClick("17", `/${tenantName}/billing`)}>
                    Billing
                  </Menu.Item>
                  <Menu.Item key="22" className="menuicon-class" onClick={() => handleMenuClick("22", `/${tenantName}/billingcrawling`)}>
                    <span className="menu-item-text" title="Billing Audit/Review"> Billing Audit/Review</span>
                  </Menu.Item>
                  <Menu.Item key="23" className="menuicon-class" onClick={() => handleMenuClick("23", `/${tenantName}/billingmasterfile`)}>
                    <span className="menu-item-text" title="Billing Masterfile">Billing Masterfile</span>
                  </Menu.Item>
                  <Menu.Item key="25" className="menuicon-class" onClick={() => handleMenuClick("25", `/${tenantName}/billinginvoiceuploadfile`)}>
                    <span className="menu-item-text" title="Billing Invoice Upload File">Billing Invoice Upload File</span>
                  </Menu.Item>
                </Menu.SubMenu>
                <Menu.Item key= "accruals" icon={<WalletOutlined alt="Accruals" style={{fontSize: 25, marginRight: 8, color: "#425BF8"}} />} onClick={ ()=> handleMenuClick("accruals", `/${tenantName}/accrualscrawling`)}>
                Accruals
              </Menu.Item>
              </>
            )}
            {isTenNinetyNine && (
              <>
                <Menu.Item key="20" icon={<img src="/Images/1099.svg" alt="1099" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />} onClick={() => handleMenuClick("20", `/${tenantName}/1099crawl`)}>
                  1099
                </Menu.Item>
              </>
            )}
            {isTimeSheetCoordinator && (
              <>
              <Menu.Item
                    key="timesheetteam"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("timesheetteam", `/${tenantName}/timesheetteam`)}
                  >
                    <span className="menu-item-text" title="Timesheet Team">
                      Timesheet Team
                    </span>
                  </Menu.Item>
              </>
            )}
            {isTimeCardFollowupCoordinator && (
              <>
              <Menu.SubMenu
                  key="timecardfollowup"
                  icon={
                    <img
                      src="/Images/Icons/Timecard F.svg"
                      alt="TimeCard Followup"
                      style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
                    />
                  }
                  title={
                    <span className="menu-item-text" title="Timecard Followup">
                      TimeCard F...
                    </span>
                  }
                >
              <Menu.Item
                    key="clientservices"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("clientservices", `/${tenantName}/clientservices`)}
                  >
                    <span className="menu-item-text" title="Client Services">
                      Client Services
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="employeecare"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("employeecare", `/${tenantName}/employeecare`)}
                  >
                    <span className="menu-item-text" title="Employee Care">
                      Employee Care
                    </span>
                  </Menu.Item>
                  <Menu.Item
                    key="timecardfollowupcrawling"
                    className="menuicon-class"
                    onClick={() => handleMenuClick("timecardfollowupcrawling", `/${tenantName}/timecardfollowupcrawling`)}
                  >
                    <span className="menu-item-text" title="Timecard Followup Audit/Review">
                      Timecard Followup Audit/Review
                    </span>
                  </Menu.Item>
                  </Menu.SubMenu>
              </>
            )}
            <Menu.Item key="14" icon={<img src="/Images/Icons/Calendr1.svg" alt="Calendar" style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }} />} onClick={() => handleMenuClick("14", `/${tenantName}/calendarview`)}>
              Calendar
            </Menu.Item>
            <Menu.Item key="15" icon={<img
              src="/Images/Icons/Email1.svg"
              alt="email"
              style={{ height: 23, width: 23, fontSize: 10, marginRight: 8 }}
            />}
              className="menuicon-class"
            >
              Email
            </Menu.Item>
            <Menu.SubMenu
              key="usefullinks"
              icon={<LinkOutlined style={{ fontSize: 25, marginRight: 8, color: "#425BF8" }} />}
              title={"Useful Links"}
            >
              <Menu.Item key="9" onClick={goToSpectranet} >Spectranet</Menu.Item>
              <Menu.Item key="10" onClick={goToPaychex} >Paychex</Menu.Item>
              <Menu.Item key="11" onClick={goToAdp} >ADP (TeamPay)</Menu.Item>
              <Menu.Item key="11" onClick={goToAdpWFN} >ADP (WFN)</Menu.Item>
              <Menu.Item key="12" onClick={goTo360Works} >360 Works</Menu.Item>
              <Menu.Item key="13" onClick={goToPeopleWorks} >PeopleWorks</Menu.Item>
            </Menu.SubMenu>


            <Menu.Item key="8" icon={<Logout />} className="menu-label">Logout</Menu.Item>
          </Menu>
        </Sider>
        <div style={{ background: "white" }}>
          <div className="sider-header"></div>
          <div className="vertical-center">
            <div
              onClick={() => setCollapsed(!collapsed)}
            >
              {
                <img src={"/Images/sideopenarrow.png"} className="navigation-arrow-side-bar" />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideNavBar;
